export default __webpack_public_path__ + "3e8ed8ac54034daa491635daa17812e5.webp";